export const ADDNEWPRODUCT = "cart/addnewproduct";
export const INCREMENT = "cart/increment";
export const DECREMENT = "cart/decrement";
